import { ModuleAdminPage } from "./ModuleAdminPage";
export function AdminWeeklyPassPage() { return <ModuleAdminPage title="週通行證" code="weekly-pass" text="管理每週任務與 2/3/5 點里程碑，點數每週重置但不可扣除。" />; }
